// src/config/api.config.js
/**
 * API Configuration
 *
 * This file centralizes API configuration values.
 * Values are loaded from environment variables (set in .env file)
 *
 * To change the backend URL or API key:
 * 1. Edit the .env file in the root directory
 * 2. Restart the development server
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8002",
  API_KEY: import.meta.env.VITE_API_KEY,
  TIMEOUT: 30000,
};

// Validate configuration
if (!API_CONFIG.API_KEY) {
  console.warn("⚠️ API Key is not set. Please check your .env file.");
}

export default API_CONFIG;
